import { Layout } from "antd";
import { createContext, useContext } from "react";
import { MainContext } from "./MainLayout";


export const PageContext = createContext({name: ""});

export function Page(props: {
    name: string,
    children: React.ReactNode
}) {

    const { selectedPage } = useContext(MainContext);
    const visible = props.name === selectedPage || !selectedPage;
    
    return (
        <PageContext.Provider value={{name: props.name}}>
            <Layout className={"mig-page h-100 " + props.name + (visible? " visible":" hidden") }>
                {props.children}
            </Layout>
        </PageContext.Provider>
    );
}